export const JsKeyCodes = {
  Esc: "Escape",
  Enter: "Enter",
  Backspace: 'Backspace'
};
